<div *ngIf="basketGroups.length">
  <div class="title">
 {{'iaa.app.locus.locusBasket.locusBasketGroups.TypesBasketsLocus' | translate}}
  </div>
  <div class="card flex;
  ">
    <p-listbox (onChange)="itemSelected($event)"
               [(ngModel)]="selectedGroup"
               [listStyle]="{
               'max-height': '11rem',
               'background-color': 'var(--iaa-color-white)',
               }"
               [options]="basketGroups">
      <ng-template let-basketGroup pTemplate="item">
        <div [ngClass]="{'is-selected': basketGroup.isSelected, 'p-highlight': basketGroup.isSelected }"
             class="flex align-items-start gap-0 p-0 border-round"
             style="direction: rtl; font: normal normal bold 0.875rem Assistant">
          <div>
            {{ basketGroup.basketType | translateLang |async}} {{ basketGroup?.basketPeriod }} ({{ basketGroup.baskets.length }})
          </div>
        </div>
      </ng-template>
    </p-listbox>
  </div>
  
</div> 

